import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import {
    LISTING_STATE_CLOSED,
    LISTING_STATE_DRAFT,
    LISTING_STATE_PENDING_APPROVAL,
    LISTING_STATE_PUBLISHED,
} from '../../../util/types';
import { IconClockXXL, IconEyeM } from '../../../icons';
import Button from '../../Button/Button';
import { useManageListingCardContext } from '../ManageListingCardContext';

import css from './ListingMedia.css';
import { getListingDisplayState } from '../helpers';
import classNames from 'classnames';
import { REASON_TO_PAUSE_STATUS_NO_ASSETS } from '../constants';

/**
 * Covers the image of a listing that is not published:
 * a description and a call to action for drafts and paused listings,
 * a clock icon for listings pending approval
 */
const StatusOverlay = ({ hasBackgroundImage }) => {
    const { listing, actions } = useManageListingCardContext();
    const displayState = getListingDisplayState(listing);

    const isDraft = displayState === LISTING_STATE_DRAFT;
    const isPaused = displayState === LISTING_STATE_CLOSED;
    const isPendingApproval = displayState === LISTING_STATE_PENDING_APPROVAL;
    const isNoAssetsDisplayState = displayState === REASON_TO_PAUSE_STATUS_NO_ASSETS;
    const withAction = isDraft || isPaused || isNoAssetsDisplayState;

    const handleOverlayButtonClick = e => {
        e.stopPropagation();

        if (isNoAssetsDisplayState) {
            return actions.navigateToImagesPage();
        }
        if (isDraft) {
            return actions.navigateToEditListingPage();
        }
        actions.reactivateListing();
    };

    return (
        <div
            className={classNames(css.overlay, {
                [css.noBackgroundImage]: !hasBackgroundImage,
            })}
        >
            <div className={css.overlayContent}>
                {withAction && (
                    <p className={css.overlayActionDescription}>
                        <FormattedMessage
                            id={`ManageListingCard.listingOverlayDesc-${displayState}`}
                        />
                    </p>
                )}
                {isPendingApproval && <IconClockXXL />}
                {withAction && (
                    <Button
                        type="button"
                        className={css.overlayActionBtn}
                        onClick={handleOverlayButtonClick}
                    >
                        <FormattedMessage
                            id={`ManageListingCard.listingOverlayAction-${displayState}`}
                        />
                    </Button>
                )}
            </div>
        </div>
    );
};

const ListingMedia = () => {
    const { listing } = useManageListingCardContext();
    const { state, publicData } = listing.attributes;
    const { viewsNum_total: viewsNum = 0, mainListingImage } = publicData;
    const isPublished = state === LISTING_STATE_PUBLISHED;
    const hasBackgroundImage = mainListingImage && typeof mainListingImage === 'string';

    return (
        <div className={css.threeToTwoWrapper}>
            {isPublished && (
                <div className={css.viewsNum}>
                    <IconEyeM /> <span>{viewsNum} Ansichten</span>
                </div>
            )}
            <div className={css.aspectWrapper}>
                <div
                    className={css.assetHolder}
                    style={
                        hasBackgroundImage
                            ? { backgroundImage: `url('${mainListingImage}')` }
                            : undefined
                    }
                />
                <code className={css.overlayBottom} />
            </div>
            {!isPublished && <StatusOverlay hasBackgroundImage={hasBackgroundImage} />}
        </div>
    );
};

export default ListingMedia;
